const ACCENT_BG  = "bg-green-500";
const ACCENT_TXT = "text-green-400";

export default function SidebarContent({
  lessons,
  currentSlug,
  currentLesson,
  sectionIdx,
  ownsCourse,
  openDay,
  openSection,
  closeSidebar = () => {},
}) {
  return (
    <>
      <h3 className={`text-lg font-bold mb-6 ${ACCENT_TXT}`}>Lessons</h3>
      <ul className="space-y-2">
        {lessons.map((l) => {
          const isCurrent = currentSlug === l.slug;
          const isLocked  = l.locked && !ownsCourse;

          const base =
            "w-full text-left px-4 py-2 rounded-lg transition-colors flex items-center gap-2";
          const state =
            isCurrent ? `${ACCENT_BG} text-black`
            : isLocked ? "bg-[#30363d] text-[#8b949e] cursor-not-allowed"
            : "hover:bg-[#21262d]";

          return (
            <li key={l.slug}>
              <button onClick={() => {openDay(l); closeSidebar();}} className={`${base} ${state}`}>
                <span>{`Day ${l.order}`}</span>
                {isLocked && <span aria-label="locked">🔒</span>}
              </button>

              {isCurrent && currentLesson?.subsections?.length > 1 && (
                <ul className="mt-1 pl-4 space-y-1">
                  {currentLesson.subsections.map((s, i) => (
                    <li key={i}>
                      <button
                        onClick={() =>{ openSection(i); closeSidebar();}}
                        className={`w-full text-left px-3 py-1 rounded text-sm ${
                          i === sectionIdx
                            ? ACCENT_TXT
                            : "text-[#8b949e] hover:text-[#c9d1d9]"
                        }`}
                      >
                        {s.title}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </>
  );
}
